import useApi from "./useApi";

export interface TrackEvent {
  category: string;
  action: string;
  entityType?: string;
  entityId?: string;
  entityName?: string;
  detail?: Record<string, unknown>;
}

/**
 * useActivityLog — call track() after successful mutations that go through
 * the V10 messaging API (workflows, rules, bots, etc.) rather than our backend.
 * Fire-and-forget: failures are silently ignored so they never block the user.
 */
export default function useActivityLog() {
  const api = useApi();

  function track(event: TrackEvent) {
    api.admin
      .post("ActivityLog/track", event)
      .catch(() => {
        // intentionally silent — audit logging must never break the UI
      });
  }

  return { track };
}
